module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA8CAMAAACn4e/8AAAAbFBMVEX////++vvvsrncVGPOEyjOESb55ObniJPULUD//f3xvcPeXm3PFir76+3pk5zWNkjzx8zgaXbQGi/88fLrnabYQFHrnKXXP1DzxsvgaHXQGS776uzpkpvVNUfxvMLeXmz54+XmiJLvsrjcU2KdRAanAAAAfklEQVR4Ae3UhwmEQBhE4dnLOZ8523+PVqAkRxDeNPBg+ffT2MJmu9vPNE3scDz5I9L5cr3ZI5Luj6c/Iun1/vgj0vf3XyASxe5Ikmbm58qL0n3CVe0+4aZ1f8bQ9X5WsAu7sAu7sAu7sAu7sAu7sAu7sAu7sAu7sAu7VmjXAJjPWpejVPJnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bh.png
// module id = 96Yk
// module chunks = 0